export const ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES = "ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY = "ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY";
export const ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST = "ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST";
export const ACTION_POST_STARASSIGNMENT_INDIVIDUAL = "ACTION_POST_STARASSIGNMENT_INDIVIDUAL";
export const ACTION_GET_LIST_HISTORICAL_TEMPLATE = "ACTION_GET_LIST_HISTORICAL_TEMPLATE";
export const ACTION_GET_STARASSIGNMENT_LIST = "ACTION_GET_STARASSIGNMENT_LIST";
export const ACTION_POST_STARASSIGNMENT_ALL = "ACTION_POST_STARASSIGNMENT_ALL";
export const ACTION_LIST_ZEN_STAR_REQUESTS = "ACTION_LIST_ZEN_STAR_REQUESTS";
export const ACTION_POST_STAR_ZEN_STATUS = "ACTION_POST_STAR_ZEN_STATUS";
export const ACTION_GET_TYPE_STAR_LIST = "ACTION_GET_TYPE_STAR_LIST";
export const ACTION_GET_STARTYPE_LIST = "ACTION_GET_STARTYPE_LIST";
export const ACTION_DOWNLOAD_TEMPLATE = "ACTION_DOWNLOAD_TEMPLATE";
export const ACTION_STAR_ZEN_STATUS = "ACTION_STAR_ZEN_STATUS";
export const ACTION_POST_TEMPLATE = "ACTION_POST_TEMPLATE";
export const ACTION_GET_CARDSlIST = "ACTION_GET_CARDSlIST";
export const ACTION_POST_ZEN_STAR = "ACTION_POST_ZEN_STAR";
export const ACTION_GET_JOB_STATUS = "ACTION_GET_JOB_STATUS";
